// Redirect component for disabled e-commerce routes.
// Shows a brief message before redirecting to djayma.com.
// Used when storefront is in "vitrine" (showcase) mode.

import { useEffect } from "react";
import { ExternalLink } from "lucide-react";

interface DjaymaRedirectProps {
  /** Full URL on djayma.com to redirect to */
  to: string;
  /** Optional label for the destination (e.g. "votre panier") */
  label?: string;
}

const DjaymaRedirect = ({ to, label }: DjaymaRedirectProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = to;
    }, 1500);
    return () => clearTimeout(timer);
  }, [to]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-5">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center mx-auto mb-6">
          <ExternalLink size={28} className="text-secondary" />
        </div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-foreground mb-3">
          Redirection vers notre boutique
        </h1>
        <p className="text-muted-foreground text-sm leading-relaxed mb-6">
          {label
            ? `Vous allez etre redirige vers ${label} sur Djayma, notre boutique en ligne.`
            : "Vous allez etre redirige vers Djayma, notre boutique en ligne."}
        </p>
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-2 h-2 rounded-full bg-secondary animate-pulse" />
          <div className="w-2 h-2 rounded-full bg-secondary animate-pulse [animation-delay:200ms]" />
          <div className="w-2 h-2 rounded-full bg-secondary animate-pulse [animation-delay:400ms]" />
        </div>
        <a
          href={to}
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-secondary text-secondary-foreground text-sm font-semibold hover:bg-gold-light transition-all duration-300"
        >
          Aller sur Djayma maintenant
          <ExternalLink size={14} />
        </a>
      </div>
    </div>
  );
};

export default DjaymaRedirect;
